import classnames from "classnames";
import { isNil } from "lodash-es";
import RcSlider, { SliderProps as RcSliderProps } from "rc-slider";
import React from "react";

import { Flex } from "../Flex";
import { IBlurable } from "../Form";

export interface ISliderProps extends Omit<RcSliderProps, "onBlur" | "value">, IBlurable {
  value?: number | null;
}

export class Slider extends React.PureComponent<ISliderProps> {
  render() {
    const classNames = classnames("el-slider", this.props.className);
    const { value, ...sliderProps } = this.props;
    const sliderValue = !isNil(value) ? value : undefined;

    return (
      <Flex padding={[false, "xs"]}>
        <RcSlider {...sliderProps} value={sliderValue} className={classNames} />
      </Flex>
    );
  }
}
